/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_cloud': {
    width: 16,
    height: 16,
    viewBox: '0 0 436.127 436.127',
    data: '<path pid="0" d="M350.359 191.016c-7.814-66.133-64.062-117.431-132.296-117.431S93.581 124.883 85.768 191.016C38.402 191.016 0 229.413 0 276.779c0 47.366 38.397 85.763 85.763 85.763h264.601c47.366 0 85.763-38.397 85.763-85.763 0-47.366-38.402-85.763-85.768-85.763z"/>'
  }
})
